import React from 'react';
import { MultiSelect, Select, TextInput } from '@mantine/core';
import { Button } from '../../../components/Button';
import {
  DATE_FILTER_OPTIONS,
  SESSION_STATE_LABELS,
  type DateFilterMode,
} from '../monitoring-page.constants';
import type { UseMonitoringPage } from '../useMonitoringPage';
import classes from '../monitoring-page.module.scss';

type SessionsFiltersProps = Pick<
  UseMonitoringPage,
  | 'sessionSessionFilter' | 'setSessionSessionFilter'
  | 'sessionStatusFilter' | 'setSessionStatusFilter'
  | 'sessionDateFilterMode' | 'setSessionDateFilterMode'
  | 'sessionExactDate' | 'setSessionExactDate'
  | 'sessionDateFrom' | 'setSessionDateFrom'
  | 'sessionDateTo' | 'setSessionDateTo'
  | 'sessionSessionOptions'
  | 'clearSessionFilters'
>;

export const SessionsFilters: React.FC<SessionsFiltersProps> = ({
  sessionSessionFilter,
  setSessionSessionFilter,
  sessionStatusFilter,
  setSessionStatusFilter,
  sessionDateFilterMode,
  setSessionDateFilterMode,
  sessionExactDate,
  setSessionExactDate,
  sessionDateFrom,
  setSessionDateFrom,
  sessionDateTo,
  setSessionDateTo,
  sessionSessionOptions,
  clearSessionFilters,
}) => (
  <div className={classes.filtersCard}>
    <div className={classes.filtersGridKitchen}>
      <div className={classes.fieldStack}>
        <MultiSelect
          label={'משמרת'}
          placeholder={'בחר משמרות'}
          data={sessionSessionOptions}
          value={sessionSessionFilter}
          onChange={setSessionSessionFilter}
          searchable
          clearable
          data-testid="monitoring-sessions-session"
        />
      </div>

      <div className={classes.fieldStack}>
        <MultiSelect
          label={'סטטוס'}
          placeholder={'בחר סטטוסים'}
          data={Object.entries(SESSION_STATE_LABELS).map(([value, label]) => ({ value, label }))}
          value={sessionStatusFilter}
          onChange={setSessionStatusFilter}
          clearable
          data-testid="monitoring-sessions-status"
        />
      </div>

      <div className={classes.fieldStack}>
        <Select
          label={'סינון תאריך'}
          data={DATE_FILTER_OPTIONS}
          value={sessionDateFilterMode}
          onChange={(value) => setSessionDateFilterMode((value as DateFilterMode) ?? 'all')}
          allowDeselect={false}
          data-testid="monitoring-sessions-date-mode"
        />
        {sessionDateFilterMode === 'exact' && (
          <TextInput type="date" value={sessionExactDate} onChange={(event) => setSessionExactDate(event.currentTarget.value)} data-testid="monitoring-sessions-date-exact" />
        )}
        {sessionDateFilterMode === 'between' && (
          <div className={classes.fieldRow}>
            <TextInput type="date" value={sessionDateFrom} onChange={(event) => setSessionDateFrom(event.currentTarget.value)} data-testid="monitoring-sessions-date-from" />
            <TextInput type="date" value={sessionDateTo} onChange={(event) => setSessionDateTo(event.currentTarget.value)} data-testid="monitoring-sessions-date-to" />
          </div>
        )}
      </div>
    </div>

    <div className={classes.filtersActions}>
      <Button variant="cancel" onClick={clearSessionFilters} dataTestId="monitoring-sessions-clear">
        {'נקה סינונים'}
      </Button>
    </div>
  </div>
);
